/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Alert,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  DropdownItem,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  editCompanyFieldChange,
  editEmailFieldChange,
  editNumberCancel,
  editNumberField,
  editNumberFieldChange as editNumberFieldChangeAction,
  getCompanyNumbers,
  getNumberByID,
  uploadFile,
} from '../../../actions/Numbers';
import util from '../../../lib/utils';
import CompanyAutocomplete from '../../CompanyAutocomplete';
import MultiInput from '../../MultiInput';
import NumberTypeSelect from '../../Numbers/NumberTypeSelect';
import UsersAutocomplete from '../../Numbers/UsersAutocomplete';
import remove from '../../../Res/Icon/remove.png';
import MultiInputDrag from '../../MultiInputDrag';
import { getVoicePorts, editAssignedNumber } from '../../../actions/EpikBoxes';

import { assignRouteInfo } from '../../../actions/Provisioning';
import NumberAutocomplete from '../../NumberAutocomplete';
import NumberRoute from '../../Numbers/NumberRoute';
import Toggle from '../../Toggle';
import { VMAIL_PROPERTY, VMAIL_ROUTE } from '../../../lib/constants';
import {
  changeAction,
  changeBulkBoxSession,
  enableBulkBoxSession,
  resetBulkBoxSession,
} from '../../../actions/BoxSessionLogging';
import NumberAtaAutocomplete from '../../NumberAtaAutoComplete';
import utils from '../../../lib/utils';
import SpinnerCircles from '../../Spinner/SpinerCircles';

const groupItems = [
  { label: 'Ring All', value: 'Ring All', tooltip: 'Rings all numbers at the same type' },
  {
    label: 'Sequential',
    value: 'Round Robin',
    tooltip: 'Rings each port in a defined sequence for 30 seconds before ringing next port',
  },
];

class EditBoxAtaNumber extends PureComponent {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.onNumberChange = this.onNumberChange.bind(this);
    this.state = {
      prepend: false,
      append: false,
      same: false,
      cidOverride: props?.number?.cidOverride || '',
      ports: [],
      selectGroup: null,
    };
    this.portArr = [];
  }

  async componentDidMount() {
    //reset bulk box session
    this.props.resetBulkBoxSession();

    const uid = true;
    const {
      number,
      getNumberByID,
      editNumberFieldChange,
      getCompanyNumbers,
      editNumberField,
      boxDetails,
      getVoicePorts,
      selectedPort,
      selectedAta,
      vmail,
    } = this.props;
    const companyId = vmail ? boxDetails.assignedTo._id : number?.company?._id;
    await getCompanyNumbers(this.token, companyId, uid);
    await getNumberByID(this.token, number?._id || '');
    editNumberField('numberByID', this.props.numberByID);
    editNumberFieldChange('company', boxDetails.assignedTo._id);
    editNumberFieldChange('companyID', boxDetails.assignedTo._id);
    editNumberFieldChange('huntType', number?.huntType || '');
    editNumberFieldChange('huntPorts', utils.removeNullish(number?.huntPorts) || '');
    this.portArr = utils.removeNullish(number?.huntPorts) || [];
    this.setState({ ports: utils.removeNullish(number?.huntPorts) || [] });
    editNumberFieldChange('assignedTo', {
      _id: boxDetails.epikBoxUser._id,
      email: boxDetails.epikBoxUser.email,
    });
    editNumberFieldChange('numDigits', 1);
    editNumberFieldChange('cidOverride', number?.cid || '');
    editNumberFieldChange('spoofType', number?.spoofType || 'none');
    editNumberFieldChange(
      'changedPort',
      selectedAta?.boxPortNumber?.toLowerCase()?.replace(' ', '') || '',
    );
    editNumberFieldChange('portLabel', selectedAta?.assignedNumberRef?.portLabel);
    this.handleNumberType({ target: { value: 'spoofType' } }, number?.spoofType || 'none');
    const huntTypeIndex = groupItems.map(e => e.value).indexOf(number?.huntType);
    this.setState({ selectGroup: groupItems[huntTypeIndex] });

    const res = await getVoicePorts(this.token, boxDetails._id);
    if (res) {
      this.allPorts = res;
      const { ports } = this.state;
      this.setState({ selectedPort: this.allPorts[0] });
      const portsWithoutDash = utils.removeDashes(ports);
      if (selectedAta?.boxPortNumber !== this.allPorts[0]) {
        portsWithoutDash.unshift(selectedAta?.boxPortNumber);
        let result = [];
        result = portsWithoutDash.filter(function(item, pos, self) {
          return self.indexOf(item) === pos;
        });
        this.setState({ ports: result });
      }
    }

    if (vmail) {
      this.VoiceMailChecks();
    }
  }

  componentWillUnmount() {
    this.portArr = [];
    this.setState({ ports: [] });
    this.props.editNumberCancel();
  }

  onNumberChange(faxNumber) {
    const { editNumberFieldChange } = this.props;
    editNumberFieldChange('number', faxNumber);
  }

  VoiceMailChecks = () => {
    this.onNumberTypeSelect(VMAIL_PROPERTY);
    this.onSelectRoute(VMAIL_ROUTE);
  };

  sortPort = () => {
    const { selectedAta } = this.props;
    if (this.allPorts) {
      let filtered = this.allPorts.filter(function(value) {
        return value !== selectedAta?.boxPortNumber;
      });
      filtered = filtered.filter(val => {
        return this.state.ports.indexOf(val) == -1;
      });
      return filtered.sort() || [];
    }
    return [];
  };

  onEditCompany = async ({ suggestion }) => {
    // [BulkAction] - Change
    const {
      changeBulkBoxSession,
      editEmailFieldChange,
      editNumberFieldChange,
      boxDetails,
    } = this.props;

    const uid = true;
    if (suggestion) {
      changeBulkBoxSession(
        `Company Changed from ${boxDetails?.assignedTo?.name} to ${suggestion?.name}`,
        'company',
      );
      await this.props.getCompanyNumbers(this.token, suggestion._id, uid);
      editNumberFieldChange('company', boxDetails.assignedTo._id);
      editNumberFieldChange('companyID', boxDetails.assignedTo._id);
      editNumberFieldChange('companyName', boxDetails.assignedTo.name);
      editEmailFieldChange(this.props.email.emails);
      editNumberFieldChange('assignedTo', {
        _id: boxDetails.epikBoxUser._id,
        email: boxDetails.epikBoxUser.email,
      });
    } else {
      editNumberFieldChange('userName', '');
    }
  };

  onEditConfirmationEmail = e => {
    // [BulkAction] - Change
    const { number } = this.props;
    this.props.changeBulkBoxSession(
      `Email Confirmation Changed from ${number?.confirmationEmail || '-'} to ${e.target.value}`,
      'emailConfirmation',
    );
    this.props.editNumberFieldChange('confirmationEmail', e.target.value);
  };

  onEditEmailChange = ({ name, suggestion }) => {
    if (suggestion) {
      this.props.editNumberFieldChange(name, suggestion._id);
    } else {
      this.props.editNumberFieldChange(name, '');
    }
  };

  onNumberTypeSelect = numberType => {
    const {
      editNumberFieldChange,
      type,
      resetBulkBoxSession,
      changeBulkBoxSession,
      vmail,
    } = this.props;
    // [BulkAction] - Reset Bulk Box Session
    resetBulkBoxSession();
    // [BulkAction] - Change
    changeBulkBoxSession(
      `Number Type Changed from ${vmail ? 'vmail' : type} to ${numberType?.value}`,
      'NumberTypeSelect',
    );
    editNumberFieldChange('type', numberType?.value);
    if (numberType?.value === 'hunt') {
      const hType = groupItems.find(hunt => hunt.value === this.props.number?.huntType) || groupItems[0];
      editNumberFieldChange('huntType', hType.value);
      this.setState({ selectGroup: hType });
    } else {
      editNumberFieldChange('huntType', '');
    }
  };

  onUserTypeSelect = numberType => {
    const { editNumberFieldChange } = this.props;
    const number1 = numberType ? numberType?.value : '';
    if (number1 !== '' && number1 !== undefined) {
      editNumberFieldChange('assignedTo', {
        _id: numberType?.value && numberType?.value._id,
        email: numberType?.value && numberType?.value.email,
      });
    }
  };

  onAllowedUserSelect = ({ suggestion }) => {
    const { number, changeBulkBoxSession } = this.props;
    // [BulkAction] - Change
    if (suggestion !== null) {
      changeBulkBoxSession(`Allow User(s) Changed to ${suggestion?.email}`, 'allowUsers');
      let addArray = true;
      number.allowedUsers.forEach(item => {
        if (item._id === suggestion._id) {
          addArray = false;
        }
      });
      if (addArray) {
        this.onEditArrChange([...number.allowedUsers, suggestion], 'allowedUsers');
      }
    }
  };

  onEditUserChange = ev => {
    // [BulkAction] - Change
    const { number, changeBulkBoxSession, editNumberFieldChange } = this.props;

    changeBulkBoxSession(
      `Caller ID Changed from ${JSON.stringify(number?.cid) || '-'} to ${ev.target.value}`,
      'callerID',
    );
    const { name, value } = ev.target;
    editNumberFieldChange(name, value);
    editNumberFieldChange('cidOverride', value);
  };

  onEditArrChange = (ev, type) => {
    if (this.props.type === 'ringDown') {
      if (ev.length > 1) {
        toast.error("You can't add more than one number.");
      } else {
        this.props.editNumberFieldChange(type, ev);
      }
    } else {
      this.props.editNumberFieldChange(type, ev);
    }
  };

  onEditArrNumChange = ev => {
    const { number } = this.state;
    // [BulkAction] - Change
    this.props.changeBulkBoxSession(
      `Forward Number Changed from ${JSON.stringify(number?.forwardNumbers) || '-'} to ${
        ev.target.value
      } `,
      'forwardNumber',
    );
    const { name, value } = ev.target;
    this.props.editNumberFieldChange(name, [value]);
  };

  handleChangeUpload = async ev => {
    // [BulkAction] - Change
    this.props.changeBulkBoxSession(`Greeting file Changed`, 'greetingFile');
    const { files } = ev.currentTarget;
    const file = new FormData();
    file.append('greeting', files[0]);

    await this.props.uploadFile(this.token, this.props.number._id, file);
  };

  onEditNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.editNumberFieldChange(name, value);
    }
  };

  setCheckedBox = e => {
    this.props.editNumberFieldChange('spoofIncomingCid', e);
  };

  handleNumberDigit = e => {
    // [BulkAction] - Change
    const { number } = this.props;
    this.props.changeBulkBoxSession(
      `Number of Digits Changed from ${number?.numDigits || '-'} to ${e.target.value}`,
      'numberOfDigits',
    );
    if (e.target.value.length <= 1) {
      if (e.target.value >= 0 && e.target.value <= 3) {
        if (e.target.value == 0) {
          this.props.editNumberFieldChange('numDigits', 1);
        } else {
          this.props.editNumberFieldChange('numDigits', e.target.value);
        }
      } else {
        this.props.editNumberFieldChange('numDigits', 1);
      }
    }
  };

  handleNumberType = (e, type) => {
    // [BulkAction] - Change
    this.props.changeBulkBoxSession(`spoofType changed to ${type}`, 'samePrependAppend');

    if (type === 'append') {
      this.setState({ append: true });
      this.setState({ prepend: false });
      this.setState({ same: false });
    }
    if (type === 'prepend') {
      this.setState({ prepend: true });
      this.setState({ append: false });
      this.setState({ same: false });
    } else if (type === 'same') {
      this.setState({ append: false });
      this.setState({ prepend: false });
      this.setState({ same: true });
    }
    this.setState({ [e.target.name]: type });
    this.props.editNumberFieldChange(e.target.name, type);
  };

  removeValue = e => {
    const { number, user } = this.props;
    if (user.role !== 'admin') {
      const valuesWIthRemoved = number.allowedUsers.filter((val, idx) => idx !== e);
      this.onEditArrChange(valuesWIthRemoved, 'allowedUsers');
    }
  };

  setPortName = e => {
    const { selectedAta, editNumberFieldChange } = this.props;
    this.setState({ selectedPort: e });
    let found = false;
    if (selectedAta?.boxPortNumber === e) {
      toast.error('Cannot select box port');
    } else if (this.state.ports.length === 0) {
      this.state.ports.push(e);
    } else {
      this.state.ports.forEach((item, idx) => {
        if (item === e) {
          found = true;
        }
        if (idx === this.state.ports.length - 1) {
          if (found) {
            toast.error('Port already selected');
          } else {
            this.state.ports.push(e);
          }
        }
      });
    }
    editNumberFieldChange('huntPorts', [selectedAta?.boxPortNumber].concat(this.state.ports));
    editNumberFieldChange('forwardUris', []);
    this.setState({ ports: this.state.ports });
  };

  move = (from, to, arr = this.state.ports) => {
    const { editNumberFieldChange, selectedAta } = this.props;
    const clone = [...arr];
    Array.prototype.splice.call(
      clone,
      to + 1,
      0,
      Array.prototype.splice.call(clone, from + 1, 1)[0],
    );
    const filtered = clone.filter(function(value) {
      return value !== selectedAta?.boxPortNumber;
    });

    this.setState({ ports: [selectedAta?.boxPortNumber].concat(filtered) }, () => {
      editNumberFieldChange('huntPorts', this.state.ports);
      editNumberFieldChange('forwardUris', []);
    });
  };

  removePort = e => {
    const { editNumberFieldChange } = this.props;
    const array = [...this.state.ports];
    array.splice(e, 1);
    this.setState({ ports: array }, () => {
      editNumberFieldChange('huntPorts', this.state.ports);
      editNumberFieldChange('forwardUris', []);
    });
  };

  typeCheck = () => {
    const { number, user, boxDetails } = this.props;
    if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
      return true;
    }
    if (
      boxDetails.myEpik === true &&
      (number.type === 'dialout' || number.type === 'fax' || number.type === 'vmail')
    ) {
      return true;
    }
    return false;
  };

  onSelectRoute = e => {
    const { selectRoute, number, editNumberFieldChange } = this.props;

    editNumberFieldChange('routeInfo', {
      route: e.route,
      gateway: e.gateway,
    });
    selectRoute(number._id, {
      routeInfo: {
        route: e.route,
        gateway: e.gateway,
      },
    });
  };

  render() {
    const {
      companies,
      type,
      number,
      user,
      email,
      editNumberFieldChange,
      boxDetails,
      onRemoveNumber,
      toggleMode,
      assignedNumbers,
      onEditPropertyKeyPress,
      selectedAta,
      vmail,
      changeBulkBoxSession,
    } = this.props;
    const disabledAdmin = user.role === 'admin' || user.role === 'enterpriseAdmin';
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                {toggleMode ? (
                  <>
                    <Input
                      disabled
                      required
                      type="text"
                      name="number"
                      value={number && number.number}
                      onChange={this.onEditNumberChange}
                      maxLength={12}
                    />

                    {user.role !== 'admin' && (
                      <div
                        onClick={() => onRemoveNumber(true)}
                        style={{
                          cursor: 'pointer',
                          margin: '10px 0px 0px 18px',
                        }}
                      >
                        <FontAwesomeIcon
                          icon="trash-alt"
                          size="sm"
                          color="#29a4ff"
                          style={{ marginRight: '0.3rem' }}
                        />
                        Remove
                      </div>
                    )}
                  </>
                ) : assignedNumbers.length !== 0 ? (
                  <NumberAtaAutocomplete
                    showUnassigned={vmail}
                    searchTerm=""
                    placeholder="Select Number"
                    numbers={assignedNumbers}
                    onChange={({ suggestion }) => {
                      if (suggestion !== null) {
                        if (suggestion.linkedToExternalAta) {
                          toast.error('Number already assigned to an Epikbox');
                        } else if (vmail && suggestion.type !== 'unassigned') {
                          toast.error('Cannot assign this number');
                        } else if (
                          !vmail &&
                          (suggestion.type === 'vmail' || suggestion.type === 'forward')
                        ) {
                          toast.error('Cannot assign this number');
                        } else if (
                          !!!boxDetails?.e911Number &&
                          (suggestion.type === 'vmail' || suggestion.type === 'voice')
                        ) {
                          toast.error(
                            'E911 must be enabled prior to assigning a voice line on the port',
                          );
                        } else {
                          // [BulkAction] - Change
                          changeBulkBoxSession(
                            `Number Changed from ${number?.number || '-'} to ${suggestion.number}`,
                            'numberChanged',
                          );
                          this.props.editAssignedNumber(suggestion);
                          const data = Object.entries(suggestion);
                          data.forEach(item => {
                            if (vmail) {
                              if (item[0] === 'type') {
                                this.props.editNumberFieldChange(item[0], VMAIL_PROPERTY.value);
                              } else if (item[0] === 'routeInfo') {
                                this.props.editNumberFieldChange(item[0], VMAIL_ROUTE);
                              }
                            } else {
                              // Ensure spoofType defaults to 'none' if not assigned or empty
                              if (item[0] === 'spoofType' && (!item[1] || item[1] === '')) {
                                this.props.editNumberFieldChange(item[0], 'none');
                              } else {
                                this.props.editNumberFieldChange(item[0], item[1]);
                              }
                            }
                          });
                          onEditPropertyKeyPress({
                            target: { name: 'assignedNumber', value: suggestion.number },
                          });
                          onEditPropertyKeyPress({
                            target: { name: 'serviceName', value: suggestion.type },
                          });
                          onEditPropertyKeyPress({
                            target: { name: 'assignedNumberRef', value: suggestion },
                          });
                          if (!vmail) {
                            this.props.assignRouteInfo(this.token, suggestion._id);
                          } else {
                            setTimeout(() => {
                              this.onSelectRoute(VMAIL_ROUTE);
                            }, 1000);
                          }
                        }
                      }
                    }}
                  />
                ) : (
                  <Alert colSpan={2} color="info" className="price-not-found-alert">
                    No Number(s) found
                  </Alert>
                )}
              </Col>
              <Col sm={type === 'hunt' ? 2 : 3}>
                <Label for="type">Type</Label>
                <NumberTypeSelect
                  toggleClassName="col-12"
                  disabledAdmin={vmail ? true : !toggleMode ? false : this.typeCheck()}
                  onTypeSelect={this.onNumberTypeSelect}
                  selectedType={vmail ? 'vmail' : type}
                  e911Enabled={boxDetails?.e911Number}
                  boxDetails={boxDetails}
                  comingFrom={vmail ? 'number' : null}
                  externalAta={true}
                />
              </Col>
              <Col sm={type === 'hunt' ? 2 : 3}>
                <label className="d-block">
                  <span className="mb-2 d-inline-block">Port Label</span>
                  <input
                    type="text"
                    value={number?.portLabel}
                    className="form-control"
                    onChange={({ currentTarget }) => {
                      changeBulkBoxSession(
                        `Port Label updated to ${currentTarget.value}`,
                        'portLabel',
                      );
                      editNumberFieldChange('portLabel', currentTarget.value);
                    }}
                  />
                </label>
              </Col>
              {type === 'hunt' || type === 't38hunt' && (
                <Col sm={2}>
                  <Label for="type" sm={12}>
                    Hunt Type
                  </Label>
                  {!!this.state.selectGroup ? (
                    <Input
                      type="select"
                      value={this.state.selectGroup?.value}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Hunt Type Changed from ${this.state.selectGroup?.value || '-'} to ${
                            e.currentTarget.value
                          }`,
                          'huntType',
                        );
                        this.setState({ selectGroup: e.currentTarget.value });
                        editNumberFieldChange('huntType', e.currentTarget.value);
                        editNumberFieldChange('forwardUris', []);
                      }}
                    >
                      {groupItems.map((item, idx) => {
                        return (
                          <option key={idx} value={item.value} title={item.tooltip}>
                            {item.label}
                          </option>
                        );
                      })}
                    </Input>
                  ) : (
                    <SpinnerCircles red={true} />
                  )}
                </Col>
              )}
            </FormGroup>
            {user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <CompanyAutocomplete
                    isDisabled
                    searchTerm={boxDetails.assignedTo?.name}
                    placeholder="Filter Company..."
                    companies={companies.docs || []}
                    onChange={this.onEditCompany}
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {vmail || (number && number.assignedTo && number.assignedTo.email) ? (
                    <UsersAutocomplete
                      disabledAdmin={!vmail}
                      searchTerm={boxDetails.epikBoxUser.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        if (e.suggestion !== null) {
                          changeBulkBoxSession(
                            `User Changed from ${number?.assignedTo?.email || '-'} to ${
                              e.suggestion.email
                            }`,
                            'user',
                          );
                        }
                      }}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            ) : (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <Input value={user.company && user.company.name} readOnly />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {number && number.assignedTo && number.assignedTo.email ? (
                    <UsersAutocomplete
                      disabledAdmin={!vmail}
                      searchTerm={boxDetails.epikBoxUser.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        if (e.suggestion !== null) {
                          changeBulkBoxSession(
                            `Email Changed from ${boxDetails?.epikBoxUser?.email || '-'} to ${
                              e.suggestion.email
                            }`,
                            'email',
                          );
                        }
                      }}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            )}
            {type === 'fax' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Email(s)
                    </Label>
                    <MultiInput
                      inputData={number && number.emails ? number.emails : []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Email(s) Changed from ${JSON.stringify(
                            number?.emails ? number.emails : [],
                          )} to ${JSON.stringify(e)}`,
                          'emails',
                        );
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Fallback email(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.fallbackEmails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `FallBack Emails Changed from ${JSON.stringify(
                            number?.fallbackEmails || [],
                          )} to ${JSON.stringify(e)}`,
                          'fallbackEmail',
                        );
                        this.onEditArrChange(e, 'fallbackEmails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardUris) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `${
                            type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                          } Changed from ${JSON.stringify(
                            number?.forwardUris || [],
                          )} to ${JSON.stringify(e)}`,
                          'forwardUris',
                        );
                        this.onEditArrChange(e, 'forwardUris');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'vmail' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Voicemail Recording Notification email(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.emails) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Voicemail Recording Notification email(s) Changed from ${JSON.stringify(
                            number?.emails || [],
                          )} to ${JSON.stringify(e)}`,
                          23,
                        );
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Greeting file (*.wav/.mp3 file)
                    </Label>
                    <Input
                      type="file"
                      name="greetinFile"
                      accept="audio/mp3,audio/wav,audio/*;"
                      onChange={this.handleChangeUpload}
                      disabled={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Voicemail Recording Notification SMS Text Number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardNumbers) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Voicemail Recording Notification SMS Text Number(s) Changed from ${JSON.stringify(
                            number?.forwardNumbers || [],
                          )} to ${JSON.stringify(e)}`,
                          21,
                        );
                        this.onEditArrChange(e, 'forwardNumbers');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'dialout' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Allowed number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.allowedNumbers) || []}
                      onChange={e => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Allowed number(s) Changed from ${JSON.stringify(
                            number?.allowedNumbers,
                          ) || []} to ${JSON.stringify(e)}`,
                          'allowedNumbers',
                        );
                        this.onEditArrChange(e, 'allowedNumbers');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Forward number
                    </Label>
                    <Input
                      required
                      type="text"
                      name="forwardNumbers"
                      value={(number && number.forwardNumbers) || []}
                      onChange={this.onEditArrNumChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Caller ID
                    </Label>
                    <Input
                      required
                      type="text"
                      name="cid"
                      value={(number && number.cid) || []}
                      onChange={this.onEditUserChange}
                    />
                  </Col>
                  <Col sm={6}>
                    <Row>
                      <Col sm={12}>
                        <Label for="spoofIncomingCid" sm={6}>
                          <Input
                            type="checkbox"
                            id="spoofIncomingCid"
                            onChange={() => {
                              // [BulkAction] - Enable
                              enableBulkBoxSession('Spoof Incoming Cid Enabled', 28);
                              this.setCheckedBox(!number.spoofIncomingCid);
                            }}
                            checked={number.spoofIncomingCid}
                            disabled={
                              (number.cid && number.cid.length < 10) ||
                              number.cid === '' ||
                              number.cid === undefined
                            }
                          />
                          Spoof cid
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'prepend')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.prepend}
                          />
                          prepend
                        </Label>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'append')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.append}
                          />
                          append
                        </Label>
                        <Label check sm={6}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'same')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.same}
                          />
                          Same called number
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <Label sm={12} for="numDigits">
                          Number of digits
                        </Label>
                        <Input
                          disabled={
                            !!(
                              number.spoofType === 'same' ||
                              number.spoofType === 'none' ||
                              !number.spoofIncomingCid
                            )
                          }
                          type="number"
                          id="numDigits"
                          name="numDigits"
                          onChange={this.handleNumberDigit}
                          value={number.numDigits}
                          max={3}
                          min={1}
                        />
                      </Col>
                      {this.state.cidOverride && this.state.cidOverride !== '' && (
                        <Col sm={6}>
                          <Label sm={12} for="numDigits">
                            Spoofed Cid
                          </Label>
                          <Input
                            disabled
                            type="text"
                            id="numDigits"
                            name="numDigits"
                            value={this.state.cidOverride}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </FormGroup>
              </>
            )}

            {type !== 'vmail' &&
            type !== 'dialout' &&
            type !== 'unassigned' &&
            type !== 'fax' &&
            type !== 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                  </Label>
                  <MultiInput
                    inputData={(number && number.forwardUris) || []}
                    onChange={e => {
                      // [BulkAction] - Change
                      changeBulkBoxSession(
                        `${
                          type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'
                        } Changed from ${JSON.stringify(
                          number?.forwardUris || [],
                        )} to ${JSON.stringify(e)}`,
                        'forwardUris',
                      );
                      this.onEditArrChange(e, 'forwardUris');
                    }}
                    disabledAdmin={disabledAdmin}
                  />
                </Col>
                {type === 'hunt'|| type === 't38hunt' && (
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Add port to hunt
                    </Label>
                    {this.sortPort() && this.sortPort().length !== 0 ? (
                      <ButtonDropdown
                        isOpen={this.state.drop}
                        toggle={() => {
                          // [BulkAction] - Change
                          changeBulkBoxSession(
                            `Add port to hunt Changed from ${this.state.drop} to ${!this.state
                              .drop}`,
                            'addPortToHunt',
                          );
                          this.setState({ drop: !this.state.drop });
                        }}
                        style={{ width: '100%' }}
                      >
                        <DropdownToggle
                          style={{
                            borderRight: 'none',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                          caret
                        >
                          {this.state.selectedPort}
                        </DropdownToggle>
                        <DropdownMenu
                          style={{
                            maxHeight: '300px',
                            overflow: 'hidden',
                            borderRight: 'none',
                            width: '100%',
                          }}
                        >
                          {this.sortPort().length !== 0 &&
                            this.sortPort().map((port, i) => (
                              <div key={i}>
                                <DropdownItem
                                  onClick={() => this.setPortName(port || `port ${i + 1}`)}
                                >
                                  {port || `port ${i + 1}`}
                                </DropdownItem>
                              </div>
                            ))}
                        </DropdownMenu>
                      </ButtonDropdown>
                    ) : (
                      <Alert colSpan={2} color="info" className="price-not-found-alert">
                        No voice ports configured on this box yet
                      </Alert>
                    )}
                    {this.state.ports.length !== 0 && (
                      <>
                        <Label for="type" sm={12}>
                          Ring Order
                        </Label>
                        <MultiInputDrag
                          removePort={this.removePort}
                          mode="number-edit"
                          type="port"
                          defaultPort={selectedAta?.boxPortNumber}
                          customClass="port-dnd"
                          inputData={this.state.ports}
                          move={this.move}
                          disabledAdmin
                        />
                      </>
                    )}
                  </Col>
                )}
              </FormGroup>
            ) : (
              ''
            )}

            {type === 'fax' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Confirmation email
                  </Label>
                  {number && (number?.forwardUris?.length !== 0 || false) ? (
                    <Input
                      type="email"
                      disabled={disabledAdmin}
                      placeholder="please specify"
                      value={number.confirmationEmail}
                      onChange={this.onEditConfirmationEmail}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Forward URI not configured
                    </Alert>
                  )}
                </Col>
                <Col sm={6}>
                  <Label for="deliveryConfirmations" sm={12}>
                    Delivery Confirmations
                  </Label>
                  <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={number.faxDeliveryConfirmation}
                      onToggle={() => {
                        // [BulkAction] - Change
                        changeBulkBoxSession(
                          `Delivery Confirmations Changed from ${
                            number.faxDeliveryConfirmation
                          } to ${!number.faxDeliveryConfirmation}`,
                          'deliveryConfirmation',
                        );
                        if (
                          number &&
                          (number?.forwardUris?.length !== 0 || false) &&
                          !disabledAdmin
                        ) {
                          this.onEditArrChange(
                            !number.faxDeliveryConfirmation,
                            'faxDeliveryConfirmation',
                          );
                        } else {
                          console.log('not configured');
                        }
                      }}
                    />
                  </Col>
                </Col>
              </FormGroup>
            ) : null}

            {type === 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Forward Number
                  </Label>
                  <Input
                    required
                    type="text"
                    name="forwardNumbers"
                    value={number?.forwardNumbers ? number.forwardNumbers[0] : ''}
                    onChange={e => {
                      // [BulkAction] - Change
                      changeBulkBoxSession(
                        `Forward Numbers Changed from ${
                          number?.forwardNumbers ? number.forwardNumbers[0] : '-'
                        } to ${e.currentTarget.value} `,
                        'forwardNumbers',
                      );
                      this.onEditArrChange([e.currentTarget.value], 'forwardNumbers');
                    }}
                    maxLength={12}
                  />
                </Col>
              </FormGroup>
            ) : null}

            {user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Route
                  </Label>
                  <NumberRoute
                    vmail={vmail}
                    number={number}
                    onChange={e => {
                      // [BulkAction] - Change
                      let rout = e?.currentTarget?.value?.gateway;
                      console.log('e?.currentTarget?.gateway', e?.currentTarget?.value);
                      console.log('e?.currentTarget?.gateway', e?.currentTarget?.value?.gateway);
                      console.log(
                        'e?.currentTarget?.gateway',
                        e?.currentTarget?.value?.['gateway'],
                      );

                      changeBulkBoxSession(
                        `Route Changed from ${JSON.stringify(number?.routeInfo) || '-'} to ${
                          e?.currentTarget.value
                        }`,
                        'routeChanged',
                      );
                      this.onSelectRoute(JSON.parse(e.currentTarget.value));
                    }}
                  />
                </Col>
              </FormGroup>
            ) : null}
            <FormGroup row>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  Allowed User(s)
                </Label>
                <UsersAutocomplete
                  disabledAdmin={disabledAdmin}
                  callsItem={(email && email.emails) || []}
                  allowedUsers
                  placeholder="Allowed users"
                  calls={(email && email.emails) || []}
                  onChange={this.onAllowedUserSelect}
                />
                <div className="email-list">
                  {number.allowedUsers &&
                    number.allowedUsers.map((value, idx) => {
                      return (
                        <div className="multi-input-item" key={value._id}>
                          <span className="item">{value.email}</span>
                          <img
                            className="remove-icon"
                            src={remove}
                            onClick={() => this.removeValue(idx)}
                            alt="remove"
                          />
                        </div>
                      );
                    })}
                </div>
              </Col>
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  number: state.UIState.numbers.editNumber,
  numberByID: state.AppState.numbers.numberByID,
  company: state.UIState.numbers.editNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.editNumber.type,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.editNumberFieldChange,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  selectedAta: state.UIState.epikBoxDetails.selectAta,
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
});

const mapDispatchToProps = dispatch => ({
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  editNumberField: (name, value) => dispatch(editNumberField(name, value)),
  editAssignedNumber: id => dispatch(editAssignedNumber(id)),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  editCompanyFieldChange: (name, value) => dispatch(editCompanyFieldChange(name, value)),
  editEmailFieldChange: emails => dispatch(editEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  getVoicePorts: (token, id) => dispatch(getVoicePorts(token, id)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  changeAction: description => dispatch(changeAction(description)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  enableBulkBoxSession: (description, key) => dispatch(enableBulkBoxSession(description, key)),
  resetBulkBoxSession: () => dispatch(resetBulkBoxSession()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditBoxAtaNumber);
